import { render, staticRenderFns } from "./EmployeesIssueBody.vue?vue&type=template&id=56c73fc5&scoped=true"
import script from "./EmployeesIssueBody.vue?vue&type=script&lang=js"
export * from "./EmployeesIssueBody.vue?vue&type=script&lang=js"
import style0 from "./EmployeesIssueBody.vue?vue&type=style&index=0&id=56c73fc5&prod&lang=scss&scoped=true"
import style1 from "./EmployeesIssueBody.vue?vue&type=style&index=1&id=56c73fc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c73fc5",
  null
  
)

export default component.exports